import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiWrench } from "@mdi/js";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const ServiceNegotiationsMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, user }) => {
    const { t } = useTranslation();

    if (!user.vendor) {
      return null;
    }

    if (!user.roles_names.includes("Service Negotiation - View")) {
      return null;
    }

    return (
      <HybridRouteListItemButtonLink
        caption="service negotiations"
        name="serviceNegotiations"
        onClick={() => handleClick("serviceNegotiations")}
        title={t("menu.serviceNegotiations.title")}
        url="/vbuyer/service_negotiations"
      >
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <Icon icon={mdiWrench} />
        </ListItemIcon>
        {!!leftMenuOpen && (
          <ListItemText
            primary={t("menu.serviceNegotiations.title")}
            slotProps={{
              primary: {
                sx: {
                  fontSize: 14,
                },
              },
            }}
            sx={{ whiteSpace: "normal" }}
          />
        )}
      </HybridRouteListItemButtonLink>
    );
  },
);
